import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

/**
 * Ouvrir une page d'un autre site sans quitter l'application.
 *
 * Sur le telephone, la vue du systeme : elle montre le domaine visite et
 * se referme d'un geste sur l'ecran qu'on avait laisse. Dans un
 * navigateur, un nouvel onglet, pour que la page en cours ne soit pas
 * perdue ; `noopener` coupe tout lien entre les deux.
 *
 * Rend `false` quand rien ne s'est ouvert — greffon absent, vue refusee,
 * adresse invalide —, pour que l'appelant ne laisse pas un bouton mort.
 */
export async function ouvrirPageExterne(url: string): Promise<boolean> {
  if (!url) return false;
  try {
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url, presentationStyle: 'popover' });
      return true;
    }
    return Boolean(window.open(url, '_blank', 'noopener,noreferrer'));
  } catch {
    return false;
  }
}
